// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1FLHe","Logo":"Header_Logo__KkMCM","DesktopOnly":"Header_DesktopOnly__1bwod"};